import React from 'react';
import styled from 'styled-components';
import breakpoints from '@repo/ui-components/breakpoints';
import Article from './Article';

const ArticleWrapper = styled.div`
  display: grid;
  grid-template: 1fr / 1fr;
  grid-gap: 0.625rem;
  @media (min-width: ${breakpoints.sm}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: ${breakpoints.md}) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1.5625rem;
  }
`;

interface ArticleProp {
  title: string;
  handle?: string;
  excerpt: string;
  image?: {
    altText?: string;
    url?: string;
    src?: string;
    localFile?: {
      childImageSharp?: any;
    };
  };
  readMore?: string;
  insights?: (value: string) => void;
}

interface ArticlesProps {
  articles: ArticleProp[];
  className?: string;
}

const Articles = ({ articles, className }: ArticlesProps) => (
  <ArticleWrapper className={className}>
    {articles.map(article => (
      <Article key={article.title} article={article} />
    ))}
  </ArticleWrapper>
);

export default Articles;
